/**
 * @desc 获取库存成本
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.InventoryCostPushToEbsRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/ebs/inventoryCostPushToEbs`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
